import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ChakraProvider } from '@chakra-ui/react'
import brandTheme from "./theme";

import App from './App';
import reportWebVitals from './reportWebVitals';
import {AuthProvider} from "./auth/AuthProvider";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
      <AuthProvider>
        <ChakraProvider theme={brandTheme}>
          <App />
        </ChakraProvider>
      </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
